import React from "react";
import { Route, Switch } from "react-router-dom";
import MasterManagement from "../masterManagement/index";
import HedgeFund from "../hedgefund";
// import HedgeFundNAV from "../hedgefund_nav/index";
import Account from "../account/index";
import Analyze from "../analyze/index";
import Profile from "../profile/index";
import Administration from "../administration";
import DashBoards from "../../components/DashBoards"
import AnalyticalTools from "../analyticalTools";
import MonthlyReport from "../monthlyReport";
import ReportForHK from '../reportForHK'
import PermissionBoundary from './PermissionBoundary'
import HKHome from '../../components/HK/Home'
import { HK_HOME_PATH } from '../../util/reportForHkAccess'
interface iProps {
  match: {
    url: string
  }
}
const Main = ({ match }: iProps): JSX.Element => (
  <PermissionBoundary>
  <Switch>
    <Route exact path={HK_HOME_PATH} component={HKHome} />
    <Route path={`${match.url}/report-for-hk`} component={ReportForHK} />
    <Route path={`${match.url}/dashboards`} component={DashBoards} />
    <Route path={`${match.url}/master`} component={MasterManagement} />
    <Route path={`${match.url}/hf`} component={HedgeFund} />
    <Route path={`${match.url}/monthly-report`} component={MonthlyReport} />
    {/* <Route path={`${match.url}/hedgefund`} component={HedgeFundNAV} /> */}
    <Route path={`${match.url}/analyze`} component={Analyze} />
    <Route path={`${match.url}/acct`} component={Account} />
    <Route path={`${match.url}/profile`} component={Profile} />
    <Route path={`${match.url}/administration`} component={Administration} />
    <Route path={`${match.url}/analytical`} component={AnalyticalTools} />
  </Switch>
  </PermissionBoundary>
);

export default Main;
